window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});
require('slick-carousel');
require('./sliders');
require('./banners');
require('./product');
require('./products');
require('./newsletter');
require('./modules/pay');
require('floating-form-labels');
require('jquery-validation');
const Basket = require('./modules/basket').default;
const Checkout = require('./modules/checkout').default;
// require('./modules/cart');

$(function () {
    $('.hb').on('click', function (e) {
        e.preventDefault();
        $('#main-nav').toggleClass('active');
    });
    $('.btn-close').on('click', function (e) {
        e.preventDefault();
        $('#main-nav').removeClass('active');
    });
    $('.ffl-wrapper').floatingFormLabels();

    $('#auth').on('click', function () {
        $(this).find('.dropdown-menu').toggle();
    });

    $('.tile-movie, .products-movie').on('click', function () {
        $(this).find('video').addClass('fullscreen');
        $(this).find('.mute').addClass('fullscreen');
        showBgAndBtnClose();
    });

    $('.mute').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($('.mute').hasClass('sound')) {
            $('.mute').removeClass('sound')
            $('video').prop('muted', true);

        }
        else {
            $('.mute').addClass('sound')
            $('video').prop('muted', false);
        }
    });

    // setTimeout(function(){
    //     $('.mute').trigger('click');
    // },300);

    $('#btn-close').on('click', function () {
        hideMovie();
        hideProduct();
    });
    $(document).keydown(function (e) {
        e.stopPropagation();
        if (e.keyCode == 27) {
            $('.dropdown-menu').hide();
            if ($('.enlarged-product').hasClass('active')) {
                hideProduct();

            }
            else {
                hideMovie();
            }
        }
    }.bind(this));

    $('.enlarge').on('click', function () {
        $src = $(this).find('img').attr('src');
        $('.enlarged-product').find('img').attr('src', $src);
        $('.enlarged-product').addClass('active');
        showBgAndBtnClose();
    });
    const $squareMovie = $('#square-movie');
    let movieIndex = $squareMovie.data('index');
    let movies = $squareMovie.data('movies');

    $squareMovie.on('ended', function () {
        movieIndex++;
        if (movieIndex > movies.length - 1) {
            movieIndex = 0;
        }
        $squareMovie.attr('src', '/movies/' + movies[movieIndex]);
    });

    function setNextMovie(e) {
        // What you want to do after the event
    }
    $('.unit').on('click', function(){
        let unit = $(this).hasClass('unit-inches') ? 'inches' : 'centimeters';
        if(unit == 'inches') {
            $('.unit-value-centimeters').removeClass('active');
            $('.unit-value-inches').addClass('active');
            $('.unit-centimeters').removeClass('active');
            $('.unit-inches').addClass('active');
        }
        else {
            $('.unit-value-centimeters').addClass('active');
            $('.unit-value-inches').removeClass('active');
            $('.unit-centimeters').addClass('active');
            $('.unit-inches').removeClass('active');
        }
        $.post('/set-unit/', {unit: unit});
    });

    $('.tab-menu').on('click', function(e){
        e.preventDefault();
        let tab = $(this).data('tab');
        $('.tab-menu').removeClass('active');
        $('.tabs .tab').removeClass('active');
        $('#tab-menu-'+tab).addClass('active');
        $('#tab-'+tab).addClass('active');
    });
    basket = new Basket();
    checkout = new Checkout();

    $('#toggle-products').on('click', function(e) {
        e.preventDefault()
        $('#products-filter-menu').slideToggle();
        $('#markets-filter-menu').hide();
    });

    $('#toggle-markets').on('click', function(e) {
        e.preventDefault()
        $('#markets-filter-menu').slideToggle();
        $('#products-filter-menu').hide();
    });

    // $('#input-discount').on('keyup', function(e) {
    //     if($(this).val().length > 5) {
    //         $.post('/check-discount-code', {code: $(this).val()}, function(response){
    //           if(response === 'ok') {
    //               documen
    //           }
    //         });
    //
    //     }
    // })

    setInterval(function(){
        switchShoutOut();
    },4000)
});

function switchShoutOut(){
    if($('#so-h1').is(":visible")){
        $('#so-h1').hide();
        $('#so-h2').fadeIn(1200);
    }
    else {
        $('#so-h2').hide();
        $('#so-h1').fadeIn(1200);
    }
}

function hideMovie() {
    $('video').removeClass('fullscreen');
    $('.mute').removeClass('fullscreen');
    hideBgAndBtnClose();
}

function hideProduct() {
    $('.enlarged-product').removeClass('active');
    hideBgAndBtnClose();
}

function hideBgAndBtnClose() {
    $('#bg-overlay').fadeOut();
    $('#btn-close').removeClass('active');
}

function showBgAndBtnClose() {
    $('#bg-overlay').fadeIn();
    $('#btn-close').addClass('active');
}
